import { Form } from "@/components/Form";
import { MessageInput } from "@/features/misc/components";
import {
  messageInputSchema,
  MessageInputSchemaModel,
} from "@/features/misc/types/schema";
import { useAddEditMessageMutation } from "@/services/modules/chat";
import { RootState } from "@/store/reducers";
import { useSelector } from "react-redux";

export const AddMessage = () => {
  const [addEditMessage] = useAddEditMessageMutation();
  const userList = useSelector((state: RootState) => state.chat.recipients);
  const recipientId = useSelector(
    (state: RootState) => state.chat.selectedRecipient?.userId
  );

  function handleSave({ comment, files }: MessageInputSchemaModel) {
    addEditMessage({
      message: comment,
      files,
      recipientId,
    });
  }

  return (
    <Form<MessageInputSchemaModel, typeof messageInputSchema>
      onSubmit={async (values, event) => {
        handleSave(values);
        event?.target.reset();
      }}
      schema={messageInputSchema}
      options={{ defaultValues: { comment: "" } }}
    >
      {(props) => (
        <MessageInput
          model={props}
          placeholder="Type your message"
          userList={userList}
          handleSend={handleSave}
        />
      )}
    </Form>
  );
};
